export const FormatString = (str) => {
  return str
    .split("_") // Split string on underscores
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize first letter of each word
    .join(" "); // Join the words with spaces
};
